import type { SVGProps } from "react";
import { memo } from "react";
const FSxforOpenZFS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#1B660F" />
        <stop offset="100%" stopColor="#6CAE3E" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M55 45.006v-2H45v2h7.287l-7.271 8H45v2h10v-2h-7.293zm-43-.728h1.953v-8.6h7.45v-1.792h-7.45v-6.7h8.813v-1.793H12zm23.998.099h2.616l3.643-5.321.076-.107-1.197-1.69zm-4.14-9.863L29 33.418c-.925-.349-1.646-.681-2.146-.986-.477-.293-.822-.621-1.03-.975-.205-.354-.308-.83-.308-1.415 0-1.054.335-1.841 1.028-2.405.69-.565 1.71-.851 3.031-.851 1.378 0 2.983.319 4.769.95l.252.088v-1.75l-.113-.05a13 13 0 0 0-2.478-.799 12 12 0 0 0-2.511-.285c-1.764 0-3.212.478-4.301 1.421-1.099.951-1.657 2.207-1.657 3.734 0 1.128.341 2.091 1.009 2.861.658.759 1.698 1.418 3.092 1.961l3.098 1.202c1.04.399 1.796.85 2.253 1.342.446.477.671 1.063.671 1.741 0 1.142-.409 2.02-1.251 2.683-.841.664-1.991 1-3.42 1-1.539 0-3.252-.336-5.092-1.002l-.252-.091v1.747l.108.051c1.568.757 3.374 1.141 5.368 1.141 1.94 0 3.533-.51 4.727-1.513 1.206-1.013 1.818-2.355 1.818-3.989 0-1.125-.311-2.078-.922-2.83-.607-.743-1.576-1.376-2.885-1.885m10.612-.99-3.291-4.699h-2.701l4.624 6.518zm2.632 7.482h2.71l-3.4-4.835 5.271-7.346h-2.587l-4.11 5.87-1.162 1.612zm12.898 4h6v-2h-6zm0 10h6v-2h-6zm0-5h10v-2H58z"
      />
    </g>
  </svg>
);
const Memo = memo(FSxforOpenZFS);
export default Memo;
